import { computed } from 'vue';
import { useStore } from 'vuex';
import { usePayment } from './usePayment';

export function useSubscription() {
  const store = useStore();
  const payment = usePayment();

  // Initialize payment provider
  payment.init();

  const subscription = computed(() => store.getters['auth/subscription']);
  
  const isPro = computed(() => subscription.value?.tier === 'PRO');
  const isTrader = computed(() => subscription.value?.tier === 'TRADER');
  const isPremium = computed(() => isPro.value || isTrader.value);
  const isActive = computed(() => {
    const status = subscription.value?.status;
    return status === 'ACTIVE' || status === 'TRIALING';
  });

  const daysUntilRenewal = computed(() => {
    if (!subscription.value?.currentPeriodEnd) return null;
    const now = new Date();
    const end = new Date(subscription.value.currentPeriodEnd);
    const diffTime = Math.abs(end - now);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  });

  const canAccessFeature = (requiredTier) => {
    if (!subscription.value) return false;
    const currentTier = subscription.value.tier; // BASIC, PRO, TRADER

    if (requiredTier === 'PRO') {
      return currentTier === 'PRO' || currentTier === 'TRADER';
    }
    if (requiredTier === 'TRADER') {
      return currentTier === 'TRADER';
    }
    return true; // BASIC
  };

  const refreshSubscription = async () => {
    await store.dispatch('auth/fetchSubscription');
  };

  const createCheckout = async (plan) => {
    await payment.createCheckout(plan);
  };

  const openBillingPortal = async () => {
    await payment.openPortal();
  };

  return {
    subscription,
    isLoading: computed(() => payment.isLoading.value), // Only for payment actions, subscription loading is handled by store generally
    error: computed(() => payment.error.value),
    
    // Actions
    refreshSubscription,
    createCheckout,
    openBillingPortal,

    // Helpers
    isPro,
    isTrader,
    isPremium,
    isActive,
    daysUntilRenewal,
    canAccessFeature
  };
}
